import '@/modules/product-variants';
import '@/modules/product-modal';

import ProductForm from '@/modules/product-form';
import FreeDeliveryBanner from '@/modules/free-delivery-banner';
import PdpMediaGallery from '@/modules/media-gallery';
import { QuantityInput } from '@/modules/cart';
import ProductCTASticky from '@/modules/product-cta-sticky';
import ProductIncludedCarousel from '@/modules/product-included-carousel';
import ProductIncludedSectionCarousel from '@/modules/product-included-section-carousel';
import ProductFeaturesCarousel from '@/modules/product-features-carousel';
import ProductComparisonCarousel from '@/modules/product-comparison-carousel';
import ProductDescription from '@/modules/product-description';

if (document.getElementsByTagName('product-form')) {
    if(!customElements.get('product-form')) {
        customElements.define('product-form', ProductForm);
    }
}

if (document.getElementsByTagName('free-delivery-banner')) {
    if(!customElements.get('free-delivery-banner')) {
        customElements.define('free-delivery-banner', FreeDeliveryBanner);
    }
}

if (document.getElementsByTagName('quantity-input')) {
    if(!customElements.get('quantity-input')) {
        customElements.define('quantity-input', QuantityInput);
    }
}

if (document.querySelector('.js-pdp-media-gallery')) {
    new PdpMediaGallery(document.querySelector('.js-pdp-media-gallery'));
}

if (document.querySelector('.js-pdp-cta-sticky')) {
    new ProductCTASticky(document.querySelector('.js-pdp-cta-sticky'));
}

const productIncludedSliders = document.querySelectorAll('.js-product-included-carousel');
if (productIncludedSliders) {
    productIncludedSliders.forEach(el => new ProductIncludedCarousel(el));
}

const productIncludedSectionSliders = document.querySelectorAll('.js-product-included-section-carousel');
if (productIncludedSectionSliders) {
    productIncludedSectionSliders.forEach(el => new ProductIncludedSectionCarousel(el));
}

const productFeaturesCarousels = document.querySelectorAll('.js-product-features-carousel');
if (productFeaturesCarousels) {
    productFeaturesCarousels.forEach(el => new ProductFeaturesCarousel(el));
}

const productComparisonCarousels = document.querySelectorAll('.js-product-comparison-carousel');
if (productComparisonCarousels) {
    productComparisonCarousels.forEach(el => new ProductComparisonCarousel(el));
}

const productDescriptions = document.querySelectorAll('.js-product-description-variants');
if (productDescriptions) {
    productDescriptions.forEach(el => new ProductDescription(el));
}
